import * as Yup from 'yup'
import { MicrosoftCloudSettingsSections } from '../../modules/flyOutOnboarding/types'

const getBaseSchemaShape = () => ({
  [MicrosoftCloudSettingsSections.PREREQUISITES]: Yup.object().shape({
    hasAccessedMpc: Yup.boolean()
      .oneOf([true], 'Please confirm the above checkbox')
      .required('This field is required.'),
    hasEnrolledInCommercialMarketplace: Yup.boolean()
      .oneOf([true], 'Please confirm the above checkbox')
      .required('This field is required.'),
    hasCompletedOrganizationProfile: Yup.boolean()
      .oneOf([true], 'Please confirm the above checkbox')
      .required('This field is required.'),
  }),
  [MicrosoftCloudSettingsSections.CLOUD_CREDENTIALS]: Yup.object().shape({
    connectionName: Yup.string().required('This field is required.').trim(),
    tenantId: Yup.string().required('This field is required.').trim(),
    clientId: Yup.string().required('This field is required.').trim(),
    clientSecret: Yup.string().required('This field is required.').trim(),
    clientSecretExpirationDate: Yup.string()
      .trim()
      .required('This field is required.'),
    mpnId: Yup.string().required('This field is required.').trim(),
    connectionTested: Yup.string().test(
      'is-not-failure',
      'Connection test failed. Please check your credentials and try again.',
      value => value !== 'failure'
    ),
  }),
})

const getAccountConfigurationSchemaShape = () => ({
  [MicrosoftCloudSettingsSections.ACCOUNT_CONFIGURATION]: Yup.object().shape({
    sellerType: Yup.array()
      .min(1, 'At least one seller type is required.')
      .required('This field is required.'),
  }),
})

const FlyoutCloudSettingsValidationSchema = Yup.object().shape({
  ...getBaseSchemaShape(),
  ...getAccountConfigurationSchemaShape(),
})

export const getFlyoutCloudSettingsValidationSchema = (
  isInIframe: boolean = false
) => {
  if (isInIframe) {
    // Exclude accountConfiguration validation when in iframe for Impartner
    return Yup.object().shape({
      ...getBaseSchemaShape(),
    })
  }
  return FlyoutCloudSettingsValidationSchema
}

export default FlyoutCloudSettingsValidationSchema
